import { useTranslate } from "ra-core";
import { useConfigurationContext } from "@/components/atomic-crm/root/ConfigurationContext.tsx";

const gridStyle = {
  backgroundImage:
    "linear-gradient(rgba(255,255,255,.04) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,.04) 1px, transparent 1px)",
  backgroundSize: "48px 48px",
};

const BULLETS = ["faster_calls", "auto_followups", "one_place"] as const;

export const LoginHero = () => {
  const { darkModeLogo, title } = useConfigurationContext();
  const translate = useTranslate();
  return (
    <div
      className="flex flex-col justify-between gap-8 bg-[#050505] p-6 text-white md:p-10"
      style={gridStyle}
    >
      <img className="h-8 w-fit" src={darkModeLogo} alt={title} />
      <div className="space-y-4">
        <p className="text-2xl font-semibold md:text-3xl">
          {translate("gavion.login.tagline")}
        </p>
        <ul className="hidden space-y-2 text-white/80 md:block">
          {BULLETS.map((b) => (
            <li key={b} className="flex items-center gap-2">
              <span className="size-1.5 rounded-full bg-primary" />
              {translate(`gavion.login.bullets.${b}`)}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};
